// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function restriction_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var polygon = Decco.arrayFromJson((function (param) {
            return Decco.arrayFromJson((function (param) {
                          return Decco.arrayFromJson(Decco.floatFromJson, param);
                        }), param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "polygon"), null));
    if (polygon.TAG === /* Ok */0) {
      var restriction_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "restriction_type"), null));
      if (restriction_type.TAG === /* Ok */0) {
        var vehicle_ids = Decco.arrayFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_ids"), null));
        if (vehicle_ids.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    id: id._0,
                    polygon: polygon._0,
                    restriction_type: restriction_type._0,
                    vehicle_ids: vehicle_ids._0
                  }
                };
        }
        var e = vehicle_ids._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".vehicle_ids" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = restriction_type._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".restriction_type" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = polygon._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".polygon" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var restrictions = Decco.arrayFromJson(restriction_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "restrictions"), null));
  if (restrictions.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              restrictions: restrictions._0
            }
          };
  }
  var e = restrictions._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".restrictions" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  restriction_decode ,
  t_decode ,
  
}
/* No side effect */
